import { TimerIcon } from 'assets/icons';
import cn from 'classnames';
import { memo, useState } from 'react';
import { Link } from 'react-router-dom';
import { DSSpinner } from '../../../designSystem';
import { BannerItemTypes } from '../Banner.types';

export const BannerItem = memo(({ link, timed, alt, image, onClick, className, placeholderClassName }: BannerItemTypes) => {
	const [loaded, setLoaded] = useState(false);

	return (
		<>
			{link && image && (
				<Link className="relative" to={link} onClick={() => onClick?.()}>
					{timed && loaded && (
						<div className="absolute z-10 top-1 left-1 rounded-4 overflow-hidden bg-white">
							<TimerIcon className="w-6 h-6" />
						</div>
					)}
					<div
						className={cn(
							'absolute inset-0 flex items-center justify-center rounded-4 transition-opacity duration-500 pointer-events-none',
							'bg-white dark:bg-dark-200',
							placeholderClassName,
							{ 'opacity-0': loaded, 'opacity-100': !loaded },
						)}
					>
						<DSSpinner className="text-primary-400 w-4 h-4" />
					</div>
					<img
						className={cn('rounded-4 block object-cover w-full h-full transition-opacity duration-300', className, {
							'opacity-0': !loaded,
							'opacity-100': loaded,
						})}
						src={image}
						alt={alt}
						loading="lazy"
						onLoad={() => {
							setLoaded(true);
						}}
					/>
				</Link>
			)}
		</>
	);
});
